import { render, staticRenderFns } from "./RecipeNutritionInfoItem.vue?vue&type=template&id=3979686a&scoped=true"
import script from "./RecipeNutritionInfoItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeNutritionInfoItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeNutritionInfoItem.vue?vue&type=style&index=0&id=3979686a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979686a",
  null
  
)

export default component.exports